import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseJsHover from 'js/modules/_base/events/mouse/hover/BaseJsHover'

const defaults = {
  instanceName: 'textAlpha3Hover',
  $names: {
    target: 'a[data-js-hover=textAlpha3]',
    text: '.c-side_btn-nav_txt,.c-breadcrumb_txt',
  },
  styleInfo: {
    alphaMouseEnter: 1.0,
    alphaMouseLeave: 0.4,
  },
}

export default class TextAlpha3Hover extends BaseJsHover {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      const $text = $target.querySelector(this.$names.text)
      if ($text) {
        gsap.killTweensOf($text, 'opacity')
        gsap.to($text, {
          opacity: this.styleInfo.alphaMouseEnter,
          duration: 0.5,
          ease: 'expo.out',
        })
      }

      gsap.delayedCall(0.2, () => {
        resolve()
      })
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      const $text = $target.querySelector(this.$names.text)
      if ($text) {
        gsap.killTweensOf($text, 'opacity')
        gsap.to($text, {
          opacity: this.styleInfo.alphaMouseLeave,
          duration: 0.6,
          ease: 'none',
          delay: 0.05,
        })
      }

      resolve()
    })
  }
}